module.exports = __webpack_public_path__ + "static/media/RoundedRect_Pink@3x.d0eaea44.png";